import React, { Component } from 'react';
import { connect } from 'react-redux';
import { detect } from 'detect-browser';

import { Route, Switch} from 'react-router-dom';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import PROCESSING_STATS_CONTROLLER from '../../controllers/processingStats';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import SupportLogin from '../supportLogin/Page';
import LoginPage from '../login/Page';
import LoginRedirect from '../oidc/LoginRedirect';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import getClientConfig from '../../utils/getClientConfig';
import CallbackPage from '../oidc/CallbackPage';

const log = new Logger('LOGGED_OUT_ROUTER', LOG_LEVELS.DEBUG);
const browser = detect();

class LoggedOutRouter extends Component {
  render() {
    const { enableAvalaraIdentity, enableAvalaraIdentityJwt } = getClientConfig();
    log.debug('render(): ', this.props);
     if (browser.name !== 'chrome'){
       return (<div><LanguageStringResolver string="notChrome"/></div>)
     }

    return (
       <Switch>
        <Route path="/supportlogin"  render={() => <SupportLogin onSuccessHandler={this.props.onLogin} onFailHandler={this.props.onLoginFail}/>}/>
        <Route exact path="/auth/callback" component={CallbackPage}/>
        
        {enableAvalaraIdentityJwt && 
          <Route render={() => <LoginRedirect />} />
        }
        {!enableAvalaraIdentity &&
          <Route render={() => <LoginPage onSuccessHandler={this.props.onLogin} onFailHandler={this.props.onLoginFail}/>} />
        }
       </Switch>
    );
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.onPageLoad(this.props.displayLanguage);
  }
}

LoggedOutRouter.defaultProps = {
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);

  return {
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (displayLanguage) => {
      log.debug('onPageLoad(): ', displayLanguage);
      dispatch(LANGUAGES_CONTROLLER.doLoad(displayLanguage));
      dispatch(PROCESSING_STATS_CONTROLLER.doResetHideFurtherNotification());
    }
  }
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(LoggedOutRouter);
